import React, { useState } from 'react';
import { ArrowDown } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { iconSize } from '@fabric-ui/utils';
import { Box, Collapse, SxProps, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';

const ArrowDownIcon = isCollapse => <ArrowDown style={{ ...iconSize(16), transform: `rotate(${isCollapse ? 0 : -90}deg)` }} />;

type CollapsedSectionProps = {
  title: React.ReactNode;
  isFocus: boolean;
  children: React.ReactNode;
  defaultCollapse?: boolean;
  sx?: SxProps;
  textColor?: string;
  fontSize?: number;
};

const CollapsedSection: React.FC<CollapsedSectionProps> = ({
  isFocus,
  title,
  defaultCollapse = true,
  children,
  fontSize = 12,
  sx,
  textColor,
}) => {
  const theme = useTheme();
  const [isCollapse, setIsCollapse] = useState(defaultCollapse);
  return (
    <Box
      sx={{
        ...flex.col,
        flexDirection: 'column',
        backgroundColor: isFocus ? theme.palette.colors.primary[100] : theme.palette.colors.neutrals[100],
        borderRadius: '12px',
        gap: '12px',
        ...sx,
      }}>
      <Box
        onClick={() => setIsCollapse(!isCollapse)}
        sx={{
          gap: 1,
          cursor: 'pointer',
          color: textColor || undefined,
          ...flex.itemsCenter,
        }}>
        {ArrowDownIcon(isCollapse)}
        <Typography sx={{ fontSize, color: textColor || theme.palette.colors.neutrals[800], width: '100%' }} variant="h6">
          {title}
        </Typography>
      </Box>
      <Collapse in={isCollapse} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </Box>
  );
};

export default CollapsedSection;
